// import { fetchJson } from './utils';
import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'admin-on-rest';
import { AUTH_GET_PERMISSIONS } from 'aor-permissions';
var Config = require('./config')

export default (type, params) => {

    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
        //
        const { username, password } = params;
        const request = new Request(Config.serverUrl+'/auth/admin-login', {
            method: 'POST',
            body: JSON.stringify({ email: username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });

        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ token ,permissions, company_name ,image, quiz_box,auth_token,company,sxolia }) => {
                setTimeout(function(){
                  window.location.reload();
                  });
                localStorage.setItem('token', token);
                localStorage.setItem('email', username);
                localStorage.setItem('permissions', permissions);
                localStorage.setItem('quiz_box', quiz_box);
                localStorage.setItem('company_name', company_name);
                localStorage.setItem('image', image);
                localStorage.setItem('auth_token', auth_token);
                localStorage.setItem('company', company);
                localStorage.setItem('sxolia', sxolia);
            });
        // accept all username/password combinations
        // return Promise.resolve();
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('permissions');
        localStorage.removeItem('company_name');
        localStorage.removeItem('image');
        localStorage.removeItem('quiz_box');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('company');
        localStorage.removeItem('sxolia');
        return Promise.resolve();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
    }
    if (type === AUTH_GET_PERMISSIONS) {
    return Promise.resolve(localStorage.getItem('permissions'));
}
    return Promise.reject('Unknown method');
};



// WEBPACK FOOTER //
// ./src/authClient.js